<template>
	<div class="row-fluid py-3 py-md-4 py-lg-5">
		<div class="col-12 col-xl-8 offset-xl-2">
			<div class="row" data-aos="fade-right">
				<div class="col-12 fuente-etiqueta">
					<p>Nuestros socios comerciales</p>
				</div>
			</div>
			<div class="row-fluid py-3 py-md-4 py-lg-5">
				<b-carousel
					:interval="8000"
					@sliding-end="onSlideEnd"
					@sliding-start="onSlideStart"
					controls
					data-ride="carousel"
					id="carouselExampleIndicators"
					indicators
					v-model="slide"
				>
					<!-- Text slides with image -->
					<b-carousel-slide :key="itemCarousel.item" v-for="(itemCarousel) in totalCarouselItems">
						<template v-slot:img>
							<div class="row m-3">
								<div
									:key="index"
									class="col-4 col-sm-3 col-md-2 mb-2 mb-lg-5"
									data-aos="fade-up"
									data-aos-delay="500"
									v-for="(item, index) in itemCarousel.data"
								>
									<div class="text-center">
										<img :src="item.rutaLogo" alt="Responsive image" class="img-fluid" loading="lazy"/>
									</div>
								</div>
							</div>
						</template>
					</b-carousel-slide>
				</b-carousel>
			</div>
		</div>
	</div>
</template>

<script>
	import servicio from "@/services/servicio-publica"

	export default {
		data() {
			return {
				totalCarousel: 0,
				totalCarouselItems: [],
				itemsLogos: [],
				//carousel
				slide: 0,
				sliding: null,
			}
		},
		mounted() {
			this.consultarBannersComerciales()
		},
		methods: {
			consultarBannersComerciales() {
				servicio
					.consultarBannerComercialLogo()
					.then((response) => {
						if (response.value) {
							this.itemsLogos = response.data
							this.cargarItemsCarousel()
						}
					})
					.catch((error) => {
						console.error(error)
					})
			},
			cargarItemsCarousel() {
				let logosPorSlide = 12
				this.totalCarousel = Math.ceil(this.itemsLogos.length / logosPorSlide)
				this.totalCarouselItems = []

				for (var i = 0; i < this.totalCarousel; i++) {
					let datos = {}

					if (i == 0) {
						datos.data = this.itemsLogos.filter(
							(dato, index) => index < logosPorSlide
						)
					} else if (i * logosPorSlide < this.itemsLogos.length) {
						datos.data = this.itemsLogos.filter(
							(dato, index) =>
								index >= logosPorSlide && index < (i + 1) * logosPorSlide
						)
					}

					datos.item = i
					this.totalCarouselItems.push(datos)
				}
			},
			onSlideStart() {
				this.sliding = true
			},
			onSlideEnd() {
				this.sliding = false
			},
		},
	}
</script>

<style>
	.fuente-etiqueta {
		font-weight: 600;
		color: var(--color-amarillo) !important;
		font-style: italic;
	}

	a.carousel-control-next,
	a.carousel-control-prev {
		width: 50px;
		position: absolute;
	}

	span.carousel-control-next-icon,
	span.carousel-control-next-icon {
		background-image: none; /*url('');*/
	}

	span.carousel-control-next-icon:after {
		content: ">";
		font-size: 35px;
		font-weight: 900;
		color: #007bff;
	}

	span.carousel-control-prev-icon:after {
		content: "<";
		font-size: 35px;
		font-weight: 900;
		color: #007bff;
		background-image: none;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.fuente-etiqueta {
			font-size: 20px !important;
		}
	}

	/* sm */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.fuente-etiqueta {
			font-size: 20px !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fuente-etiqueta {
			font-size: 24px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.fuente-etiqueta {
			font-size: 28px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.fuente-etiqueta {
			font-size: 32px !important;
		}
	}
</style>